<template>
  <div>
    <BannerManage :title="'Guihua首页轮播'" :position="'GuiHua-banner'" />
    <BannerManage :title="'Guihua Journal'" :position="'Journal'" />
    <BannerManage :title="'Guihua Co-organizer'" :position="'Co-organizer'" />
    <BannerManage :title="'Guihua Topic '" :position="'Guihua-topic'" />
  </div>
</template>

<script>
import BannerManage from "../../componentSet/BannerCarousel.vue";
export default {
  components: {
    BannerManage,
  },
  data() {
    return {
      position: null,
    };
  },
};
</script>

<style scoped lang="scss">
.pc-list {
  padding: 42px 30px 57px;
  margin-top: 20px;
  margin-bottom: 30px;
  border-radius: 4px;
  box-shadow: $shadowCard;
  overflow: hidden;
  position: relative;
  .pc-banner-title {
    display: inline-block;
    font-size: 20px;
    padding: 0 0 30px 0;
    -ms-flex-item-align: end;
    align-self: flex-end;
  }
  .btnViewDetail1 {
    position: absolute;
    right: 125px;
    display: inline-block;
    width: 90px;
    height: 30px;
    border-radius: 4px;
    border: 1px solid $timeBtn;
    outline: none;
    background: none;
    font-family: $chinese;
    font-size: 12px;
    color: $timeBtn;
    cursor: pointer;
  }
  .btnViewDetail1:hover {
    background: $blueBtn;
    color: white;
  }
  .pc-list-head {
    // margin-top: 20px;
    // margin-bottom: 30px;
    margin: 20px 0 30px;
    border-top: 1px solid #c0c0c0;
    padding-top: 30px;
    letter-spacing: 1px;
    font-family: $chinese;
    font-size: 14px;
    color: $mainTitle;
    display: flex;
    justify-content: flex-end;
    .pc-list-head-handle {
      // float: right;
      display: flex;
      align-items: center;
      .pc-list-head-btn {
        display: flex;
        border: 1px solid $schoolTagBorder;
        margin-right: 30px;
        border-radius: 4px;
        button,
        p {
          cursor: pointer;
          font-family: $chinese;
          font-size: 14px;
          color: $mainTitle;
          letter-spacing: 1px;
        }
        button {
          width: 100px;
          background: none;
          outline: none;
          padding: 10px 0px;
          box-sizing: content-box;
          border: none;
        }
        span {
          height: 16px;
          border: 1px solid $schoolTagBorder;
          align-self: center;
        }
        button:hover {
          background: $blueBtn;
          color: white;
        }
        p {
          margin-left: 32px;
        }
      }
    }
  }

  /deep/ .el-table__row {
    height: 60px;
    .el-input {
      .el-input__inner {
        height: 30px;
        text-align: center;
        width: 80px;
      }
      .el-select__caret {
        line-height: 30px;
      }
    }
    .el-input--suffix {
      .el-input__inner {
        width: 100%;
      }
    }
  }
  .pc-list-table::-webkit-scrollbar {
    height: 10px;
    background: red;
  }
  .pc-list-table {
    overflow: visible !important;
    .btnViewDetail {
      width: 90px;
      height: 30px;
      border-radius: 4px;
      border: 1px solid $timeBtn;
      outline: none;
      background: none;
      font-family: $chinese;
      font-size: 12px;
      color: $timeBtn;
      cursor: pointer;
    }
    .btnViewDetail:hover {
      background: $blueBtn;
      color: white;
    }
    /deep/ .cell {
      text-align: center !important;
      font-family: $chinese !important;
      font-size: 14px !important;
      color: $mainTitle !important;
      .el-icon-error {
        font-size: 18px;
        margin-right: 20px;
        color: $fork;
      }
      .el-icon-success {
        font-size: 18px;
        color: $blueBtna;
      }
    }

    /deep/ .el-switch__core {
      width: 54px !important;
      height: 20px !important;
      display: flex;
      align-items: center;
    }
    .switch-is-active {
      /deep/ .el-switch__core {
        &::before {
          content: "有效";
          font-size: 8px;
          color: white;
          padding-left: 6px;
        }
      }
    }
    .cover_images {
      width: 70px;
      height: 45px;
    }
    .switch-is-not-active {
      /deep/ .el-switch__core {
        &::before {
          content: "无效";
          font-size: 8px;
          color: white;
          padding-left: 22px;
        }
      }
    }
    /deep/ .el-table__body-wrapper {
      min-height: 100px;
    }
    /deep/ .is-leaf {
      border-top: 1px solid #ebeef5;
      background: $base-color !important;
      font-weight: normal !important;
    }
    /deep/ .el-switch__core {
      width: 54px !important;
      height: 20px !important;
      display: flex;
      align-items: center;
    }
  }

  .pagination {
    margin-top: 40px;
  }
  /deep/ .pc-pagin {
    justify-content: flex-end !important;
  }
}
.guihua-recommend {
  @include box-model;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/guihua/magazineBanner.vue